import React from 'react';
import { Button } from 'antd';
import { observer } from 'mobx-react-lite';
import { useLoan } from '../../stores/store';
import { stepFinished } from '../../nav';
import AppFormItem from '../../loan/components/AppFormItem';
import { pushToDataLayer, getStepLabel } from '../../utils/gtm';

const PreviousButton: React.FC = observer(() => {
  const loanStore = useLoan();

  return (
    <AppFormItem name="back" wrapperCol={{ offset: 0, span: 24 }}>
      <Button
        name="back"
        type="default"
        htmlType="button"
        onClick={() => {
          loanStore.navDirection = -1;
          // skip validation
          // noinspection JSIgnoredPromiseFromCall
          const { loan } = loanStore;
          if (loan) {
            pushToDataLayer('e_applicationAction', {
              application_category: 'financing application',
              application_action: 'back',
              application_label: getStepLabel(loan.currentStep),
              loan_purpose: loan.purpose.toLowerCase(),
            });
          }
          stepFinished();
          return false;
        }}
      >
        Back
      </Button>
    </AppFormItem>
  );
});

export default PreviousButton;
